import { getClient } from '@/lib/restClient';
import { StoreManagementDeliveryStoreActivationJobsService } from '@/services/StoreManagement/DeliveryStoreActivationJobs/StoreManagementDeliveryStoreActivationJobsService';

export type StoreManagementDeliveryStoreActivationJobUpdateParams = {
  integration_date: Date;
};

export const useStoreManagementDeliveryStoreActivationJobUpdate = async (
  id: string,
  params: StoreManagementDeliveryStoreActivationJobUpdateParams
): Promise<void> => {
  const storeManagementDeliveryStoreActivationJobsService =
    new StoreManagementDeliveryStoreActivationJobsService(getClient());
  return await storeManagementDeliveryStoreActivationJobsService.update(
    id,
    params
  );
};
